import { MERCHANT_ENTRY_PATH, MERCHANT_HOME_PATH } from './merchantExperience';
export { MERCHANT_ENTRY_PATH, MERCHANT_HOME_PATH };

const AUTH_PATHS = new Set(["/login", "/acceso", "/recuperar-contrasena"]);

export const getMerchantEntryContinuation = ({ pathname = "", search = "" } = {}) => {
  if (
    pathname === MERCHANT_ENTRY_PATH || pathname === `${MERCHANT_ENTRY_PATH}/` ||
    pathname === MERCHANT_HOME_PATH || pathname === `${MERCHANT_HOME_PATH}/`
  ) {
    return MERCHANT_ENTRY_PATH;
  }

  const requested = new URLSearchParams(search).getAll("returnTo");
  return requested.length === 1 && requested[0] === MERCHANT_ENTRY_PATH
    ? MERCHANT_ENTRY_PATH
    : "";
};

export const withMerchantEntryContinuation = (path, continuation) => {
  if (continuation !== MERCHANT_ENTRY_PATH || !AUTH_PATHS.has(path)) return path;
  return `${path}?${new URLSearchParams({ returnTo: MERCHANT_ENTRY_PATH })}`;
};

export const getMerchantHomePath = (canAccessModule) =>
  canAccessModule("inicio") ? MERCHANT_HOME_PATH : "/app";
